/**
 * Portal target for overlays (menus, popovers, modals).
 *
 * Browser fullscreen (`element.requestFullscreen()`) only paints descendants of
 * the fullscreen element. Portals into `document.body` are invisible while a
 * ListView / Map / Dashboard is fullscreen — use this helper instead.
 */
export function getPortalContainer(): HTMLElement {
  if (typeof document === 'undefined') {
    // SSR / tests without DOM — callers should only portal on the client.
    return null as unknown as HTMLElement
  }
  const fs = document.fullscreenElement
  if (fs instanceof HTMLElement) return fs
  return document.body
}
